import { useContext } from "react";
import { ApiClientContext } from "../top-level-contexts";

export function useApiClients() {
  const context = useContext(ApiClientContext);
  return context;
}
